import React  from 'react';
import { useSelector, useDispatch } from 'react-redux';

import SalesUsersList from './components/SalesUsersList';

import { Modal, Button } from 'hosman-material';
import { S_UserPlus } from 'hosman-material';

import { updateDisplaySalesUsersModal, updateSalesUser } from '../../../../../../../reducers/SellerApp/salesUsersSlice';

const SalesUsersModal = () => {
  const { salesUser } = useSelector((state) => state.sellerSalesUsers);
  const dispatch = useDispatch();

  return (
    <Modal isOpen={salesUser === null} closeModal={() => dispatch(updateDisplaySalesUsersModal(false))}>
      <div className='flex flex-col gap-8 text-ih-indigo p-8 bg-ih-purple-5' id='SalesUsersModal' data-testid='SalesUsersModal'>
        <div className='flex flex-col gap-3'>
          <p className='h2 md:w-2/3'>Qui sont les personnes à tenir informées de la vente ?</p>
          <p>Ex : un locataire, un ex-conjoint, un associé SCI...</p>
        </div>

        <div className='flex flex-col md:flex-row md:justify-between items-center'>
          <p className='h3'>Contacts à informer :</p>
          <Button label='Ajouter un contact' type='secondary' onClick={() => dispatch(updateSalesUser({ signatory: false }))} icon={S_UserPlus} />
        </div>

        <SalesUsersList />

        <div className='flex justify-center md:justify-end'>
          <Button label='Fermer' onClick={() => dispatch(updateDisplaySalesUsersModal(false))} />
        </div>
      </div>
    </Modal>
  );
}

export default SalesUsersModal;
